import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import './Resultados.css';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function AvaliacoesDetalhes({ avaliacoes, onReavaliacao, onUpdate }) {
  const { user } = useAuth();
  const [confirmando, setConfirmando] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!avaliacoes || avaliacoes.length === 0) {
    return <p style={{padding:'10px', color:'#6b7a95', fontStyle:'italic'}}>Esta apresentação ainda não possui avaliações.</p>;
  }

  const handleReavaliar = async (avaliacao) => {
    setLoading(true);
    try {
      await axios.delete(`/api/avaliacoes/${avaliacao.id}/reavaliar/`, {
        headers: { 'X-CSRFToken': getCookie('csrftoken') }
      });
      toast.success(`Avaliação de @${avaliacao.avaliador_username} apagada! Liberada para reavaliação.`);
      setConfirmando(null);
      if (onReavaliacao) onReavaliacao();
      if (onUpdate) onUpdate();
    } catch (err) {
      toast.error('Erro ao apagar avaliação.');
    }
    setLoading(false);
  };

  return (
    <div className="detalhes-avaliacoes-container">
      <h4>Detalhes das Avaliações</h4>
      {user?.is_superuser && (
        <p className="reav-aviso">🔑 Como superusuário você pode apagar uma avaliação para liberar reavaliação.</p>
      )}
      <table className="tabela-detalhes">
        <thead>
          <tr>
            <th>Avaliador(a)</th>
            <th>Nota Final</th>
            {user?.is_superuser && <th style={{textAlign:'center'}}>Reavaliação</th>}
          </tr>
        </thead>
        <tbody>
          {avaliacoes.map(avaliacao => (
            <tr key={avaliacao.id}>
              <td>@{avaliacao.avaliador_username}</td>
              <td><strong>{parseFloat(avaliacao.nota_final_calculada).toFixed(2)}</strong></td>
              {user?.is_superuser && (
                <td style={{textAlign:'center'}}>
                  {confirmando === avaliacao.id ? (
                    <div className="reav-confirm">
                      <span>Apagar?</span>
                      <button
                        className="reav-btn-sim"
                        onClick={() => handleReavaliar(avaliacao)}
                        disabled={loading}
                      >
                        ✓ Sim
                      </button>
                      <button
                        className="reav-btn-nao"
                        onClick={() => setConfirmando(null)}
                        disabled={loading}
                      >
                        ✗ Não
                      </button>
                    </div>
                  ) : (
                    <button
                      className="reav-btn"
                      onClick={() => setConfirmando(avaliacao.id)}
                      title="Apagar avaliação para reavaliação"
                    >
                      🔄 Reavaliar
                    </button>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AvaliacoesDetalhes;
